import React, { forwardRef, memo } from 'react';
import HBInput from '../HBInput/HBInput';
import { HBInputProps } from '../HBInput/HBInput.types';
import HBInputField, { HBInputFieldProps } from '../HBInputField/HBInputField';
import useFormFieldProps, {
    FormFieldProps,
    TFormInputValidationProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';

const HBFormInputField = (
    props: Omit<FormFieldProps<HBInputFieldProps>, TFormInputValidationProps>
) => {
    const fieldProps = useFormFieldProps(props, true);
    const validationProps = useFormInputValidationProps(props.id);

    return <HBInputField {...fieldProps} {...validationProps} />;
};

export const HBFormInput = memo(
    forwardRef<
        HTMLInputElement,
        Omit<FormFieldProps<HBInputProps>, TFormInputValidationProps>
    >((props, ref) => {
        const inputProps = useFormInputProps(props, true);
        const validationProps = useFormInputValidationProps(props.id);

        return <HBInput {...inputProps} {...validationProps} ref={ref} />;
    })
);

export default memo(HBFormInputField);
